module.exports = __webpack_public_path__ + "img/aba.db108116.png";